<template>
  <div class="confirmPanel">
    <!--确认订单弹出框-->
    <el-dialog  
      :visible.sync="confirmPanelShow" 
      width="1000px"  
      center  
      :z-index="11"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"  
      >
      <div class="confirmPanel-title">
          <div>确认订单</div>
      </div>
      <!--订单信息-->
      <div class="housing">
          <ul class="housing-list">
              <li><p>订单类型:</p><div>{{orderDetail.order_type==1?'住宿订单':'纯会议订单'}}</div></li>
              <li><p>团  号:</p><div>{{orderDetail.title}}</div></li>
              <li v-if="orderDetail.order_type==1"><p>入离日期:</p><div>{{orderDetail.date_in | formatTimestamp(2)}} ~ {{orderDetail.date_out | formatTimestamp(2)}} (共{{Math.abs(orderDetail.date_out - orderDetail.date_in)/86400}}晚)</div></li>
              <li v-if="orderDetail.order_type==1"><p>早餐类型:</p><div>{{orderDetail.breakfast}}</div></li>
              <li v-if="orderDetail.eatery"><p>餐饮需求:</p><div>{{orderDetail.eatery | formatVar('eateryArr')}}</div></li> 
              <li v-if="orderDetail.other"><p>其他需求:</p><div><span class="mr-1"  v-for="item in starns(orderDetail.other,'meetRoomObj')" :key="item">{{item}}</span></div></li> 
              <li v-if="orderDetail.remark"><p>备注信息:</p><div>{{orderDetail.remark}}</div></li> <!--{{orderDetail.province_name}}省&ensp;{{orderDetail.city_name}}市&ensp;{{orderDetail.district_name}}-->
          </ul>
      </div>
      <!--用房信息-->
      <OrderHousing :onDehalf="1" :orderDetail="modifyDetail" :modify="modify"></OrderHousing>
      <div  class="confirmPanel-bottoms">
          <!--订单总额-->
          <!--修改时订单总额-->
          <div class="price" v-if="modify">
              <div>订单总额：
                <span v-if="price.discount_price">¥{{ price.total_price*1+Math.abs(price.discount_price)}}</span>
                <p>¥{{ price.total_price}}</p>
              </div>
              <el-popover
                placement="top-start"
                width="200"
                trigger="hover"
                >
                <div>
                  <ul class="expenseDetails">
                    <li v-if="price.room_price">
                      <p>用房</p>
                      <span>¥{{ price.room_price}}</span>
                    </li>
                    <li v-if="price.meeting_price">
                      <p>会议室</p>
                      <span >¥{{ price.meeting_price}}</span>
                    </li>
                    <li v-if="price.discount_price">
                      <p>优惠房</p>
                      <span class="text-success">¥{{ price.discount_price}}</span>
                    </li>
                    <li v-if="price.add_price">
                      <p>附加需求</p>
                      <span >¥{{ price.add_price}}</span>
                    </li>
                  </ul>
                </div>
                <el-button class="ml-2" size="mini" slot="reference">费用明细</el-button>
              </el-popover>
          </div>
            <el-button  @click="revokeUndo" type="primary" class="bottom"   v-if="orderDetail.edit_launch_uid==userLoginMessage.uid">撤销修改</el-button>
            <template v-else>
              <el-button  @click="submitOrder(1)"  type="primary" class="bottom" disabled >同意</el-button>
              <el-button  @click="submitOrder(0)"  type="danger" class="bottom"  >不同意</el-button>
            </template>
            <el-button  class="bottom" @click="$emit('onShow')">返回  </el-button>
      </div>
      <!--提示-->
      <div class="hint" v-if="price.total_price<1">
        订单总额不可小于1元
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters,mapActions,mapState} from 'vuex'
import provinces from '@/assets/utils/provinces'             //省份信息
import OrderHousing from '@/views/Order/OrderDetail/HotelOrder/Components/OrderHousing'
export default {
  name: 'confirmPanel',
  components: {OrderHousing},
  props: {
    edit_launch_uid: {
      type: String,
      default: '',
    },
    modify: {
      type: Boolean,
      default: true,
    },
    confirmPanelShow: {
      type: Boolean,
      default: false
    },
    orderDetail: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
    modifyDetail:{},
      roomList:{},
      price:{},                       //修改时订单金额      
    };
  },
  computed: {
        ...mapGetters(['storeInfo']),
        ...mapState(['userLoginMessage']),
  },
  watch: {
  },
  created() {},
  mounted() {},
  methods: {
    ...mapActions(['POST_ComputeOrderHotelPrice','OrderHotelDetail','EditRevoke','POST_EditOrderHotel']),
    //获取查看修改详情
    POST_OrderHotelDetail(res){
      console.log(res)
      this.OrderHotelDetail({
        oid:res.data,
        successFun:res=>{
            //价格值
            this.price.total_price=res.price;
            this.price.room_price=res.room_need_arr.price;
            this.price.meeting_price=res.meeting_need_arr.price;
            this.price.add_price=res.add_need_arr.price;
            this.price.discount_price=res.discount_need_arr.price;
            this.modifyDetail=res
        }
      })
    },
    //星级需求
    starns(e,type){
        let result
        if(!e)return['无']
        if(!e.toString().includes(',')){
          result=new Array(e)
        }else{
          if(!Array.isArray(e)){
            result=e.split(',')
          }
        }
        let n=this.$options.filters['formatStars'](result,type);
        return n
    },
    //获取本地地址信息
    parseAddress(res){
      if(!res.city)return ''
      let city = provinces.find(item => item.id == res.city);
      let province = provinces.find(item => item.id == res.province);
      let district='';
      res.district.split(',').map(rict=>{
        district+= provinces.find(item => item.id == rict).title+'  '
      })
      return `${city.title}省、${province.title}市、${district}`;
    },
    //撤销修改订单
    revokeUndo(){
        this._confirm('是否要撤销修改？',() => {
            this.EditRevoke({
                oid:this.orderDetail.oid,
                successFun:() => {
                    this._alert('操作成功');
                    this.$emit('getorderDetail');
                }
            })
        })
    },
    //同意修改订单
    submitOrder(action){

      this._confirm(`是否要${action==1?'同意':'拒绝'}修改？`,() => {
        this.POST_EditOrderHotel({
          data:{
            oid:Number(this.orderDetail.oid),
            action
          },
          successFun:() => {
            this._alert('操作成功');
            this.$emit('getorderDetail');
          }
        })
      })
    }
  }
};
</script>

<style lang="scss" scoped>
  .confirmPanel-title{
      font-size: 18px;
      font-weight: bold;
      color: #333;
      margin-bottom: 12px;
      text-align: center;
      overflow: hidden;

  }
  
  .housing{
      width: 92%;
      padding: 16px 2%;
      background-color: #fff;
      border-radius: 6px;
      border: 1px #eee solid;
      margin: 0 auto;
      margin-top: 20px;
      padding-top:4px;
  }
  .housing-list{
      display: flex;
      flex-wrap: wrap;
      li{
          width: 49%;
          margin-top: 12px;
          p{
              width: 80px;
              color: #999;
              float: left;
          }
          div{
              display: inline-block;
              width: 78%;
          }
      }
  }
  .confirmPanel-bottoms{
      display: flex;
      justify-content: center;
      width: 96%;
      margin: 0 auto;
      margin-top: 24px;
  }
  .price{
      margin-right:auto;
      line-height: 30px;
      color: var(--smtc-color-text-black);
      font-weight: bold;
      display: flex;
      span{
          color: var(--smtc-color-text-shallow);
          text-decoration: line-through;
          margin-right: 6px;
          font-weight: normal;
          font-size: 12px;
      }
      p{
          display: inline-block;
          color: red;
      }
  }
  .hint{
    font-size: 12px;
    text-align: right;
    margin-right: 16px;
    margin-top: 6px;
    color: red;
  }
  .el-icon-question{
    color: var(--smtc-color-primary);
    font-size: 16px;
    margin-left: 6px;
    margin-top: 7px;
  }
  .expenseDetails{
    width: 100%;
    li{
      border-bottom: 1px #eee solid;
      padding: 12px 0;
      display: flex;
      justify-content: space-between;
      font-size: 12px;
      color: #333;
    }
    li:last-child{
      border-bottom: none;
    }
  }
</style>
<style>
  .confirmPanel .el-dialog__header{
    padding: 0;
  }
</style>
